/* eslint-disable import/no-cycle */
import { SET_CHATBOT_PARAMS, GET_CHATBOT_PARAMS } from '@/store/types';

const INIT_STATE = () => ({
    chatBotParams: null
});

const getters = {
    chatBotParams: (state) => state.chatBotParams,
};

const mutations = {
    [SET_CHATBOT_PARAMS]: (state, payload) => {
        state.chatBotParams = payload;
    }
};

const actions = {
    async [GET_CHATBOT_PARAMS]() {
        return this.state.chatBot.chatBotParams;
    }
};

const state = () => ({ ...INIT_STATE() });

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
